module.exports = __webpack_public_path__ + "img/n3.df058607.svg";